import "./TextInput.css";

const TextInput = ({value, callbackOnChange, callbackOnKeyPress, placeholder}) => {

  return (
    <input
      type="text"
      className="word-input"
      value={value}
      onChange={callbackOnChange}
      onKeyPress={callbackOnKeyPress}
      placeholder={placeholder}
    />
  )
};

export { TextInput };